import React, { Component } from "react";

import { connect } from "react-redux";

export interface GroupsProps {
    compareConfigurations: any[];
    selectedForComparison: number[];
}

class GroupsComponent extends Component<GroupsProps, {}> {
    renderJackpotGroups = index => {
        const GAME_TYPES = {
            0: "bingo",
            1: "spins",
            2: "lotto",
            3: "keno"
        };
        return (
            <tr key={index}>
                {this.props.compareConfigurations.map(config => {
                    const groups =
                        config.settings.jackpot_groups.use_terminal_groups ==
                        true
                            ? config.settings.jackpot_groups.terminal_groups
                            : config.settings.jackpot_groups.game_groups;
                    if (typeof groups[index] !== "undefined") {
                        return (
                            <td className="value" key={`${index}-${config.id}`}>
                                {config.settings.jackpot_groups
                                    .use_terminal_groups && (
                                    <div className="terminal-group">
                                        <div>
                                            <span>Name</span>
                                            {groups[index].id}
                                        </div>
                                        <div>
                                            <span>Description</span>
                                            {groups[index].description}
                                        </div>
                                    </div>
                                )}
                                {config.settings.jackpot_groups
                                    .use_game_groups && (
                                    <div className="game-group">
                                        <div>
                                            <span>Name</span>
                                            {groups[index].name}
                                        </div>
                                        <div className="bullets-select">
                                            <div>
                                                <span>Games</span>

                                                {groups[
                                                    index
                                                ].game_instances.map(
                                                    instanceId => {
                                                        let game =
                                                            config.settings.game_settings.find(
                                                                instance =>
                                                                    instance.id ==
                                                                    instanceId
                                                            );
                                                        if (game) {
                                                            return (
                                                                <div
                                                                    key={
                                                                        instanceId
                                                                    }
                                                                    className={`bullet ${
                                                                        GAME_TYPES[game.type]
                                                                    }`}
                                                                >
                                                                    {game.name}
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </td>
                        );
                    }

                    return (
                        <td className="value" key={config.id}>
                            <div>&nbsp;</div>
                        </td>
                    );
                })}
            </tr>
        );
    };

    render() {
        let rowsCount = 0;
        let hasGroups = false;

        this.props.compareConfigurations.map(config => {
            if (
                config.settings.jackpot_groups.terminal_groups.length > 0 ||
                config.settings.jackpot_groups.game_groups.length > 0
            ) {
                hasGroups = true;
            }

            if (
                config.settings.jackpot_groups.use_terminal_groups == true &&
                config.settings.jackpot_groups.terminal_groups.length >
                    rowsCount
            ) {
                rowsCount =
                    config.settings.jackpot_groups.terminal_groups.length;
            }

            if (
                config.settings.jackpot_groups.use_game_groups == true &&
                config.settings.jackpot_groups.game_groups.length > rowsCount
            ) {
                rowsCount = config.settings.jackpot_groups.game_groups.length;
            }
        });

        const groupRows = Array.from(Array(rowsCount).keys());

        if (hasGroups == false) {
            return null;
        }

        return (
            <table id="table-comparative">
                <thead>
                    <tr>
                        <td colSpan={this.props.compareConfigurations.length}>
                            Jackpot Groups
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr className="inner-header">
                        <td colSpan={this.props.selectedForComparison.length}>
                            Group Type
                        </td>
                    </tr>
                    <tr>
                        {this.props.compareConfigurations.map(config => {
                            return (
                                <td className="value" key={config.id}>
                                    <div>
                                        {config.settings.jackpot_groups
                                            .use_terminal_groups == true &&
                                            "Terminal Group"}
                                        {config.settings.jackpot_groups
                                            .use_game_groups == true &&
                                            "Game Group"}
                                    </div>
                                </td>
                            );
                        })}
                    </tr>
                    <tr className="inner-header">
                        <td colSpan={this.props.selectedForComparison.length}>
                            Groups
                        </td>
                    </tr>
                    {groupRows.map(index => this.renderJackpotGroups(index))}
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsComponent);
